<template>
  <div class="crm">
    <span @click="goBack" class="back">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
    width="18px" height="18px"
    ><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
    </svg>
    </span>
    <page-header
      title="Blacklisted Contacts"
      breadcrumb="Dashboard > Customer Engagement > Blacklisted Contacts"
    />
    <blacklisted-contacts />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import BlacklistedContacts from "./BlacklistedContactsTable";

export default {
  components: {
    PageHeader,
    BlacklistedContacts,
  },
  methods: {
    goBack() {
      return this.$router.go(-1)
    }
  }
};
</script>

<style scoped>
.back{
  padding: 30px;
  cursor:pointer;
}
</style>
